import {
  imageThumb,
  imageInfo
} from "./image/image";

class Utils {
  //计算2点间距离
  getDistance(lat1, lng1, lat2, lng2) {
    let s = this.computedDistance(lat1, lng1, lat2, lng2)
    return this.fixedDistance(s)
  }

  fixedDistance(s) {
    let distance = 0;
    if (s > 1000) {
      distance = (s / 1000).toFixed(1) + "km";
    } else {
      distance = s + "m";
    }
    return distance;
  }

  computedDistance(lat1, lng1, lat2, lng2) {
    const rad = function (d) {
      return (d * Math.PI) / 180.0;
    };
    let radLat1 = rad(lat1);
    let radLat2 = rad(lat2);
    let a = radLat1 - radLat2;
    let b = rad(lng1) - rad(lng2);
    let s =
      2 *
      Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
        )
      );
    return Math.round(s * 6378.137 * 1000);
  }

  // 需要token的跳转
  async jumpToken(url, item) {
    try {
      await this.hasToken();
      this.navTo(url, item)
    } catch (e) {
      this.navTo("/pagesAccount/login/login")
    }
  }

  /**
   * @param {Object} params.type - 3：patrol；2：maintain
   * @param {String} params.morph_id - 计划ID
   * @param {String} params.lnglat - 当前所在位置 lng,lat
   * @param {String} params.project_id - 项目ID
   *
   * @returns Promise 当且仅当成功获取完定位、api提交成功才触发 resolve
   */
  _uploadOwnLocation(params) {
    return new Promise(() => {
      Location.getLocation().then((res) => {
        params.lnglat = `${res.longitude},${res.latitude}`;
      });
    });
  }

  // 验证身份证
  checkCode(val) {
    if (val.length > 15) {
      const p =
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      const code = val.substring(17);
      if (p.test(val)) {
        let sum = 0;
        for (let i = 0; i < 17; i++) {
          sum += val[i] * factor[i];
        }
        if (parity[sum % 11] == code.toUpperCase()) {
          return true;
        }
      }
      return false;
    } else {
      return /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(
        val
      );
    }
  }

  //校验手机号
  codeVerification(phone) {
    var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
    // var message = '';
    if (!reg.test(phone)) {
      // message = '请输入正确的手机号码'
      return false;
    }
    return true;
  }

  imageThumb(img, options, mode) {
    return imageThumb(img, options, mode);
  }

  imageInfo(url) {
    return imageInfo(url);
  }
}

export default new Utils();